<template>
  <!--Main Content-->
  <div class="main-content px-0 app-content">
    <!--Main Content Container-->
    <div class="container-fluid">
      <!--Page Header-->
      <Breadcrumb />
      <!--Page Header-->
      <!-- <div class="forms mb-5 card rounded">
        <RenewalForm :user="this.user" />
      </div> -->

      <div class="">
        <div class="row row-sm">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
            <div class="card">
              <div class="card-body pb-0 border-bottom">
                <div class="d-flex mb-3">
                  <h6 class="card-title mb-0">Renewals</h6>
                  <div class="card-option ml-auto d-none d-md-flex">
                    <div class="mr-2">
                      <!-- <router-link to="/createmaintenance"><button class="btn btn-primary btn-sm rounded-lg fs-13"><i class="mdi mdi-plus-circle-outline"></i>Create New Maintenance </button></router-link> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="">
                <form class="card m-3" @submit.prevent="getRenewals()">
                  <div class="m-3 p-3 row">
                    <div class="col-md-6">
                      <!-- <h5 class="mb-3 bg-light p-2">Generate By Date</h5> -->
                      <p>Start Date</p>
                      <input
                        class="form-control"
                        type="date"
                        required
                        v-model="startDate"
                        name="start"
                      />
                    </div>

                    <div class="col-md-6">
                      <!-- <h5 class="mb-3 bg-light p-2">
                      Generate By Category Or Status
                    </h5> -->

                      <p>End Date</p>
                      <input
                        v-model="endDate"
                        class="form-control"
                        type="date"
                        required
                        name="end"
                      />
                    </div>
                    <button v-if="loading" class="btn btn-primary" disabled>
                      Loading
                      <div
                        class="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span style="width: 2px" class="sr-only text-light"
                          >Loading...</span
                        >
                      </div>
                    </button>
                    <input
                      v-else-if="renewals.length == 0"
                      class="ml-3 btn btn-primary"
                      type="submit"
                      value="Generate"
                    />
                    <button class="ml-5 btn btn-warning" @click.prevent="reset">
                      Reset
                    </button>
                  </div>
                </form>
                <div class="card m-3">
                  <div class="table-responsive">
                    <table
                      id="example"
                      class="table table-striped"
                      style="width: 100%"
                    >
                      <thead>
                        <tr>
                          <th>Asset Id</th>
                          <th>Asset Name</th>
                          <th>Renewal Name</th>
                          <th>Renewal Type</th>
                          <th>Registration Number</th>
                          <th>Expiry Date</th>
                          <th>Renewal Cost</th>
                          <th>Driver Name</th>
                          <th>Total Amount</th>
                          <th>Staff Assigned To</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="renewal in renewals" :key="renewal.id">
                          <td>{{ renewal.assetId }}</td>
                          <td>{{ renewal.assetName }}</td>
                          <td>{{ renewal.name }}</td>
                          <td>{{ renewal.renewalTypeId }}</td>
                          <td>{{ renewal.registrationNumber }}</td>
                          <td>{{ renewal.expirydate.split("T")[0] }}</td>
                          <td>{{ renewal.renewalCost }}</td>
                          <td>{{ renewal.driverName }}</td>
                          <td>{{ renewal.totalAmount }}</td>
                          <td>{{ renewal.staffAssignTo }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- COL END -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
//import RenewalForm from "@/components/RenewalForm";
import Breadcrumb from "@/components/Breadcrumb";

export default {
  components: {
    //RenewalForm,
    Breadcrumb,
  },

  props: ["user", "BaseURL"],

  data() {
    return {
      loading: false,
      renewals: [],

      startDate: "",
      endDate: "",
      categoryId: 0,
      status: "",
    };
  },

  methods: {
    getRenewals() {
      this.loading = true;
      fetch(
        this.BaseURL +
          "/getRenewalByDate/" +
          this.startDate +
          "/" +
          this.endDate,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          this.renewals = data;

          if (this.renewals.length == 0) {
            this.loading = false;
            alert(
              `No Data Available Within Specified Date Or Category To Show`
            );
          } else {
            this.loading = false;
            $(() => {
              $("#example").DataTable({
                dom: "Bfrtip",
                buttons: [
                  "colvis",
                  "copyHtml5",
                  "csvHtml5",
                  "excel",
                  "pdf",
                  "print",
                ],
              });
            });
          }
          //console.log(data);
          // this.isSuccessful = data.isSuccess;
          // this.errorMessage = data.message;
        });
    },

    reset() {
      window.location.reload(true);
    },

    beforeCreate() {
      if (localStorage.getItem("role") !== "User") {
        window.location = "/error";
      }
    },
  },
};
</script>